<template>
<w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
  <component slot="activeView" :is="activeView" :activeView="activeView"></component>
</w-settings-summary>
</template>

<script>
import findIndex from 'lodash/findIndex';
import { getValueAfterCheckEmpty } from '@/utils/string';
import isEmpty from 'lodash/isEmpty';
import summaryApi from '@/api/settings/settings-summary';
import WSettingsSummary from '@/components/template/SettingsSummary';
import WOidSettings from './OidSettings';
import WScriptSettings from './ScriptSettings';
import WIpManagementSettings from './IpManagementSettings';
import WDeviceModelSettings from './DeviceModelSettings';
import WDeviceAccountSettings from './DeviceAccountSettings';
import WRuleViolationSettings from './RuleViolationSettings';
import WTrafficSettings from './TrafficSettings';

export default {
  name: 'WNetdeviceSettings',
  components: {
    WOidSettings,
    WSettingsSummary,
    WScriptSettings,
    WIpManagementSettings,
    WDeviceModelSettings,
    WDeviceAccountSettings,
    WRuleViolationSettings,
    WTrafficSettings,
  },
  data() {
    return {
      activeView: null,
      menu: [
        {
          id: 'oidSettings',
          name: 'OID 설정',
          desc: ['네트워크 장비의 OID 설정이 가능합니다.', '성능 OID 및 사용자 정의 OID를 추가할 수 있습니다.'],
          data: null,
          orderbyIndex: 1,
        },
        {
          id: 'scriptSettings',
          name: '스크립트 설정',
          desc: ['각 벤더사 별 수행 스크립트를 설정할 수 있습니다.', '스케줄 설정으로 해당 스크립트를 주기적으로 수행할 수 있습니다.'],
          data: null,
          orderbyIndex: 2,
        },
        {
          id: 'deviceModelSettings',
          name: '장비 모델 관리',
          desc: ['각 벤더의 모델에 대한 정보를 관리합니다.', '벤더사 모델별 EOL/EOS 정보를 설정할 수 있습니다.'], // 벤더사 모델별 펌웨어 이미지와 EOL/EOS 정보를 설정할 수 있습니다.
          data: null,
          orderbyIndex: 4,
        },
        {
          id: 'ruleViolationSettings',
          name: '보안 정책 위배 관리',
          desc: ['정부 기관에서 권고한 네트워크 장비 보안 지침에 의거하여', '보안 정책 위배 장비 검출 및 조치 방법을 설정할 수 있습니다.'],
          data: null,
          orderbyIndex: 5,
        },
        {
          id: 'ipManagementSettings',
          name: 'IP대역 관리',
          desc: ['IP 대역 별 사용/미사용 현황 관리를 수행합니다.', 'IP 및 MAC 정보를 활용하여 IP대역 별 사용/미사용 현황을 제공합니다.'],
          data: null,
          orderbyIndex: 6,
        },
        {
          id: 'deviceAccountSettings',
          name: '장비 계정 관리',
          desc: ['네트워크 장비 계정에 대한 관리 및 정보 수집을 수행합니다.', '장비 별 계정 정보 수집과 필요 시 패스워드 변경 수행이 가능합니다.'],
          data: null,
          orderbyIndex: 7,
        },
        {
          id: 'trafficSettings',
          name: '트래픽 설정',
          desc: ['플로우 분석에 필요한 IP 그룹과 인터페이스 그룹을 설정합니다.', '그룹이 설정되면 그룹별 플로우 분석이 가능합니다.'],
          data: null,
          orderbyIndex: 8,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    onChangeMenu(activeView) {
      this.activeView = activeView;
    },
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
      this.loadData();
    },
    loadData() {
      summaryApi.getNetworkSettingSummaryCount().then((response) => {
        const result = response.data;
        if (result.success === true && !isEmpty(result.data)) {
          const data = result.data;

          const oidSettingsData = [`현재 등록된 사용자 정의 OID는 <em>${getValueAfterCheckEmpty(data.oidCount)}개</em> 입니다.`];
          // const scheduleSettingsData = [`현재 등록된 스케줄 수는 <em>${getValueAfterCheckEmpty(dummyData.scheduleCount)}개</em>입니다.`];
          const scriptSettingsData = [`현재 등록된 스크립트 수는 <em>${getValueAfterCheckEmpty(data.scriptCount)}개</em>입니다.`];
          const deviceModelSettingsData = [`현재 등록된 장비 모델 수는 <em>${getValueAfterCheckEmpty(data.productCount)}개</em>입니다.`];
          const ruleViolationSettingsData = [`현재 등록된 정책위배 수는 <em>${getValueAfterCheckEmpty(data.policyCount)}개</em>입니다.`];
          const ipManagementSettingsData = [`현재 등록된 IP대역 수는 <em>${getValueAfterCheckEmpty(data.ipCount)}개</em>입니다.`];
          const deviceAccountSettingsData = [`현재 등록된 장비 계정 수는 <em>${getValueAfterCheckEmpty(data.accountCount)}개</em>입니다.`];
          const trafficSettingsData = [`현재 등록된 그룹의 수는 <em>${getValueAfterCheckEmpty(data.groupCount)}개</em>입니다.`];

          const oidSettingsIndex = findIndex(this.menu, (item) => item.id === 'oidSettings');
          this.menu[oidSettingsIndex].data = oidSettingsData;

          // const scheduleSettingsIndex = findIndex(this.menu, (item) => item.id === 'scheduleSettings');
          // this.menu[scheduleSettingsIndex].data = scheduleSettingsData;

          const scriptSettingsIndex = findIndex(this.menu, (item) => item.id === 'scriptSettings');
          this.menu[scriptSettingsIndex].data = scriptSettingsData;

          const deviceModelSettingsIndex = findIndex(this.menu, (item) => item.id === 'deviceModelSettings');
          this.menu[deviceModelSettingsIndex].data = deviceModelSettingsData;

          const ruleViolationSettingsIndex = findIndex(this.menu, (item) => item.id === 'ruleViolationSettings');
          this.menu[ruleViolationSettingsIndex].data = ruleViolationSettingsData;

          const ipManagementSettingsIndex = findIndex(this.menu, (item) => item.id === 'ipManagementSettings');
          this.menu[ipManagementSettingsIndex].data = ipManagementSettingsData;

          const deviceAccountSettingsIndex = findIndex(this.menu, (item) => item.id === 'deviceAccountSettings');
          this.menu[deviceAccountSettingsIndex].data = deviceAccountSettingsData;

          const trafficSettingsIndex = findIndex(this.menu, (item) => item.id === 'trafficSettings');
          this.menu[trafficSettingsIndex].data = trafficSettingsData;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/index.vue